import { gatewayInstance } from "../axiosInstance";
import { SERVICE_ENDPOINT } from "../const";

export const searchGSDivision = async (data) => {
  try {
    const response = await gatewayInstance.post(
      `${SERVICE_ENDPOINT.TRANSPORT}/master/gs-division/search`,
      data,
    );
    return response.data?.data || [];
  } catch (e) {
    console.error(e);
    throw e;
  }
};

export const createGSDivision = async (data) => {
  const response = await gatewayInstance.post(
    `${SERVICE_ENDPOINT.TRANSPORT}/master/gs-division`,
    data,
  );
  return response.data;
};

export const updateGSDivision = async (data) => {
  const response = await gatewayInstance.put(
    `${SERVICE_ENDPOINT.TRANSPORT}/master/gs-division`,
    data,
  );
  return response.data;
};

export const getGSDivisionById = async (id) => {
  try {
    const response = await gatewayInstance.get(
      `${SERVICE_ENDPOINT.TRANSPORT}/master/gs-division/${id}`,
    );
    return response.data?.data?.[0] || null;
  } catch (e) {
    console.error(e);
    throw e;
  }
};
